import type { FormSchema, Schema } from '@cli-types/core-engine/schema.js'
import type { SchemaDiffField, SchemaDiffResult } from '@cli-types/core-engine/snapshots.js'
import { collectCustomComponents } from './collect-custom-components.js'
import { collectFields } from './collect-fields.js'

export function diffSchemas(
  before: Schema | FormSchema,
  after: Schema | FormSchema
): SchemaDiffResult {
  const beforeFields = new Map(collectFields(before).map((field) => [field.name, field]))
  const afterFields = new Map(collectFields(after).map((field) => [field.name, field]))

  const added: SchemaDiffField[] = []
  const removed: SchemaDiffField[] = []
  const changed: Array<{ before: SchemaDiffField; after: SchemaDiffField }> = []

  for (const [name, beforeField] of beforeFields) {
    const afterField = afterFields.get(name)
    if (!afterField) {
      removed.push(beforeField)
      continue
    }
    if (beforeField.type !== afterField.type) {
      changed.push({ before: beforeField, after: afterField })
    }
  }

  for (const [name, afterField] of afterFields) {
    if (!beforeFields.has(name)) {
      added.push(afterField)
    }
  }

  const beforeComponents = new Set(collectCustomComponents(before))
  const afterComponents = new Set(collectCustomComponents(after))

  return {
    added: added.sort((a, b) => a.name.localeCompare(b.name)),
    removed: removed.sort((a, b) => a.name.localeCompare(b.name)),
    changed: changed.sort((a, b) => a.before.name.localeCompare(b.before.name)),
    customComponents: {
      added: Array.from(afterComponents)
        .filter((name) => !beforeComponents.has(name))
        .sort(),
      removed: Array.from(beforeComponents)
        .filter((name) => !afterComponents.has(name))
        .sort()
    }
  }
}
